import React from "react";
import { connect } from "react-redux";
import { Popup } from "devextreme-react";
import GenerateItemReorderRecordsGrid from "../../../../../po/transactions/common/GenerateItemReorderRecordsGrid";

function CreateRequisitionPopup(props) {
    return (<>
        {props.showPopup.visible==true ? (
        <Popup
            visible={props.showPopup.visible}
            onHiding={() => props.setShowPopup(prevFormData=>({...prevFormData,visible:false}))}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={props.title}
            container="#root"
            width="100vw"
            height="100vh"
        >
              <GenerateItemReorderRecordsGrid dataSource={props.showPopup.data} formFields={props.showPopup.formFields}
          setLoadIndicatorVisible={props.setLoadIndicatorVisible}/>
        </Popup>):(null)}
    </>);
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CreateRequisitionPopup);
